import { inject, Injectable } from '@angular/core'
import { ArticlesApiClient, UpdateAllArticleParams } from '@efp/api'
import { Article } from '../../../models/article'
import { ArticleDao } from '../article.dao'
import { firstValueFrom } from 'rxjs'

@Injectable()
export class ArticleHttpDao extends ArticleDao {
  private readonly articleApiClient = inject(ArticlesApiClient)

  async findAllByStockId(stockId: number, doka360ProjectUid?: string): Promise<Article[]> {
    return firstValueFrom(
      this.articleApiClient.getAllArticles({
        stockId,
        doka360ProjectUid,
      })
    )
  }

  async delete(id: number): Promise<void> {
    await firstValueFrom(
      this.articleApiClient.deleteArticle({
        id,
      })
    )
  }

  async update(article: Article): Promise<void> {
    await firstValueFrom(
      this.articleApiClient.updateArticle({
        id: article.id,
        body: article,
      })
    )
  }

  async updateAll(articles: Article[], stockId: number): Promise<void> {
    await firstValueFrom(
      this.articleApiClient.patchAllArticles({
        stockId,
        body: articles.map((article) => {
          return {
            amount: article.amount,
            articleId: article.articleId,
            id: article.id,
            name: article.name,
          } as UpdateAllArticleParams
        }),
      })
    )
  }

  async createArticles(articles: Article[], stockId: number): Promise<number[]> {
    return await firstValueFrom(
      this.articleApiClient.createArticles({
        stockId,
        body: articles,
      })
    )
  }
}
